import { isFunction } from 'lodash';

// 获取勾选状态
export const getIndeterminateAndChecked = (data = [], checkedKeys = [], key) => {
    // 勾选数量
    const checkNum = checkedKeys.length;

    // 所有子项数量
    const allSubTotal = getItemNum(data);
    let checked;
    let indeterminate;

    if (key === 'ALL') {
        checked = checkNum && checkNum >= allSubTotal; // 勾选数量等于所有子项数量
        indeterminate = checkNum && checkNum < allSubTotal; // 存在勾选但没有全选上
    } else {
        const subCheckNum = treeFilter(data, v => checkedKeys.includes(v.key)).length; // 子列表勾选数量
        checked = subCheckNum >= allSubTotal; // 勾选数量等于子项列表数量
        indeterminate = subCheckNum && subCheckNum < allSubTotal; // 存在勾选但没有全选上
    }

    return { indeterminate, checked };
};

// 获取子项 key, 不含带 children 的那一项
export const getKeys = data => {
    let keys = [];
    data.map(v => {
        if (v.children?.length) {
            keys.push(...getKeys(v.children));
        } else {
            keys.push(v.key);
        }
    });

    return keys;
};

// 计算子列表勾选数量
export const treeFilter = (data, func) => {

    if (!data?.length) {
        return []
    }

    if (!isFunction(func)) {
        return []
    }

    let result = [];
    data.map(item => {
        if (item.children?.length) {
            result.push(...treeFilter(item.children, func));
        } else if (func(item)) {
            result.push(item)
        }
    })
    return result;
};

// 获取子项数量，不含带 children 的那一项
export const getItemNum = data => {
    let num = 0;
    data.map(v => {
        if (v.children?.length) {
            num = num + getItemNum(v.children);
        } else {
            num++;
        }
    });

    return num;
};
